module.exports = __webpack_public_path__ + "static/media/l12_voice_two_v2.52892874.mp3";